import { render, staticRenderFns } from "./RasioKeuangan.vue?vue&type=template&id=4dd01fa2&scoped=true"
import script from "./RasioKeuangan.vue?vue&type=script&lang=js"
export * from "./RasioKeuangan.vue?vue&type=script&lang=js"
import style0 from "./RasioKeuangan.vue?vue&type=style&index=0&id=4dd01fa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd01fa2",
  null
  
)

export default component.exports